"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetImageExtension = void 0;
const core_1 = require("@remirror/core");
const remirror_1 = require("remirror");
const Extensions_1 = require("../Extensions");
let AssetImageExtension = class AssetImageExtension extends core_1.NodeExtension {
    get name() {
        return Extensions_1.NodeName.AssetImage;
    }
    createTags() {
        return [core_1.ExtensionTag.InlineNode, core_1.ExtensionTag.Media];
    }
    createNodeSpec(extra, override) {
        return {
            inline: true,
            draggable: true,
            selectable: true,
            ...override,
            attrs: {
                ...extra.defaults(),
                matrixAssetId: {},
                matrixIdentifier: {},
                matrixDomain: { default: this.options.matrixDomain },
                src: { default: '' },
            },
            parseDOM: [
                {
                    tag: 'img[data-matrix-asset-id]',
                    getAttrs: (node) => {
                        if (!(0, core_1.isElementDomNode)(node)) {
                            return false;
                        }
                        const matrixAssetId = node.getAttribute('data-matrix-asset-id');
                        const matrixIdentifier = node.getAttribute('data-matrix-identifier');
                        const matrixDomain = node.getAttribute('data-matrix-domain');
                        if (!matrixAssetId || !matrixIdentifier || !matrixDomain) {
                            return false;
                        }
                        return {
                            ...extra.parse(node),
                            matrixAssetId,
                            matrixIdentifier,
                            matrixDomain,
                        };
                    },
                },
            ],
            toDOM: (node) => {
                const { matrixAssetId, matrixIdentifier, matrixDomain, src, ...rest } = (0, core_1.omitExtraAttributes)(node.attrs, extra);
                return [
                    'img',
                    {
                        ...extra.dom(node),
                        ...rest,
                        src,
                        'data-matrix-asset-id': matrixAssetId,
                        'data-matrix-identifier': matrixIdentifier,
                        'data-matrix-domain': matrixDomain,
                    },
                ];
            },
        };
    }
    insertAssetImage(attrs) {
        return ({ tr, dispatch }) => {
            const { from, to } = (0, remirror_1.getTextSelection)(tr.selection, tr.doc);
            const node = this.type.create({ ...attrs, src: attrs.url });
            dispatch?.(tr.replaceRangeWith(from, to, node));
            return true;
        };
    }
};
__decorate([
    (0, core_1.command)()
], AssetImageExtension.prototype, "insertAssetImage", null);
AssetImageExtension = __decorate([
    (0, core_1.extension)({
        defaultOptions: {
            matrixDomain: '',
        },
        defaultPriority: core_1.ExtensionPriority.High,
    })
], AssetImageExtension);
exports.AssetImageExtension = AssetImageExtension;
